var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-security-forces.4e4a300a.png","uri@2x": __webpack_public_path__ + "icon-security-forces.9d64560e.png","uri@3x": __webpack_public_path__ + "icon-security-forces.41f62811.png",
    width: 20,
    height: 20
});